/**
 * Zieht aus einer fehlgeschlagenen API-Antwort eine Meldung, die man anzeigen kann.
 *
 * **Warum eigens dafür eine Funktion:** Der Server antwortet in drei Formen — als nackter Text
 * (`BadRequest("…")`), als JSON mit `message` (globale Fehlerbehandlung) oder gar nicht (etwa ein
 * HTTP 404 ohne Rumpf, wenn der Endpunkt auf dem Server noch nicht ausgeliefert ist). Die naive
 * Variante liefert im dritten Fall einen **leeren** Text, und eine leere Meldung rendert nicht —
 * die Seite sieht dann genauso aus wie „keine Daten vorhanden", obwohl die Anfrage gescheitert ist.
 * Genau dieser Fall hat schon einmal Zeit gekostet.
 *
 * Der Statuscode wird mitgegeben, weil er die Ursache oft eindeutig macht: 404 heißt „diesen
 * Endpunkt gibt es (noch) nicht", 403 „nicht berechtigt", 503 „Fremdsystem nicht erreichbar".
 */
export const apiErrorMessage = (error: any, fallback: string): string => {
    const status: number | undefined = error?.response?.status;
    const body = error?.response?.data;

    const fromBody =
        typeof body === 'string' && body.trim().length > 0 ? body.trim()
            : typeof body?.message === 'string' && body.message.trim().length > 0 ? body.message.trim()
                : typeof error?.message === 'string' && error.message.trim().length > 0 ? error.message.trim()
                    : null;

    if (fromBody && status) return `${fromBody} (HTTP ${status})`;
    if (fromBody) return fromBody;
    if (status === 404) return `${fallback} (HTTP 404 — der Endpunkt ist auf dem Server nicht vorhanden. Ist die Serverversion aktuell?)`;
    if (status) return `${fallback} (HTTP ${status})`;
    return fallback;
};
